export const SUPPORTED_LOCALES = ['fa'] as const;

export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number];

export const DEFAULT_LOCALE: SupportedLocale = 'fa';

const RTL_LOCALES = new Set<string>(['fa', 'ar', 'he', 'ur']);

export function isRtlLocale(locale: string): boolean {
  return RTL_LOCALES.has(locale.split('-')[0] ?? locale);
}

export function normalizeLocale(language: string | undefined | null): SupportedLocale {
  const base = language?.split('-')[0];

  return SUPPORTED_LOCALES.includes(base as SupportedLocale) ? (base as SupportedLocale) : DEFAULT_LOCALE;
}

export function readStoredLocale(): SupportedLocale {
  if (typeof window === 'undefined') return DEFAULT_LOCALE;

  return normalizeLocale(localStorage.getItem('i18nextLng'));
}

/** BCP 47 tag for `Intl` / `toLocaleString` (Persian digits & calendar when fa). */
export function intlLocaleTag(locale?: string): string {
  const base = normalizeLocale(locale ?? readStoredLocale());

  return base === 'fa' ? 'fa-IR' : 'en-US';
}
